import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import axios from 'axios'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'

import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import HomeSliderListing from '../components/listing/HomeSliderListing'
import AwardsAndAchievementsSection from '../components/AwardsAndAchievementsSection'

import BannerImg from '../assets/images/800home/HomeBanner.webp'
import BgMiddle from '../assets/images/800home/Img2.webp'
import TypeSkyline from '../assets/images/800home/Img1.webp'
import TypeVilla from '../assets/images/why-dubai/Img6.webp'
import TypePenthouse from '../assets/images/why-dubai/Img2.webp'
import TypeTowers from '../assets/images/listing/Img1.webp'
import TypeAerial from '../assets/images/listing/Img5.webp'
import TypeHouses from '../assets/images/why-800-homes/Img2.webp'
import TypeInterior from '../assets/images/landing-page/Img3.webp'
import CommPalm from '../assets/images/800home/Img5.webp'
import CommTerrace from '../assets/images/800home/Img7.webp'
import CommLounge from '../assets/images/why-dubai/Img7.webp'
import CommBedroom from '../assets/images/why-dubai/Img3.webp'
import Icon1 from '../assets/images/Icons/1.png'
import Icon2 from '../assets/images/Icons/2.png'
import Icon3 from '../assets/images/Icons/3.png'
import Icon4 from '../assets/images/Icons/4.png'
import Icon5 from '../assets/images/Icons/5.png'
import Icon6 from '../assets/images/Icons/6.png'
import Icon7 from '../assets/images/Icons/7.png'
import Icon8 from '../assets/images/Icons/8.png'
import Icon9 from '../assets/images/Icons/9.png'
import Icon10 from '../assets/images/Icons/10.png'
import Icon11 from '../assets/images/Icons/11.png'
import Icon12 from '../assets/images/Icons/12.png'
import Icon13 from '../assets/images/Icons/13.png'
import Icon14 from '../assets/images/Icons/14.png'
import Icon15 from '../assets/images/Icons/15.png'
import Icon16 from '../assets/images/Icons/16.png'
import Icon17 from '../assets/images/Icons/17.png'
import Icon18 from '../assets/images/Icons/18.png'
import Icon19 from '../assets/images/Icons/19.png'
import Icon20 from '../assets/images/Icons/20.png'

import ExpertFaraaz from '../assets/images/Faraz.webp'
import ExpertBhwna from '../assets/images/BhwnaManvani.jpg'
import ExpertAanil from '../assets/images/Aanil.webp'
import ExpertLakshay from '../assets/images/Lakshay.png'
const SERVICE_ICONS = {
    home: <path d="M7 23 24 8l17 15M12 20v21h24V20M20 41V29h8v12" />,
    key: (
        <>
            <circle cx="31" cy="17" r="9" />
            <path d="M25 23 9 39M13 35l4 4M18 30l4 4" />
        </>
    ),
    doc: <path d="M12 6h18l8 8v28H12zM30 6v8h8M18 31l7-6 7 6v7H18z" />,
    pin: (
        <>
            <path d="M24 6c-8 0-12 6-12 12 0 9 12 24 12 24s12-15 12-24c0-6-4-12-12-12z" />
            <circle cx="24" cy="18" r="4" />
        </>
    ),
    building: <path d="M9 42V15l12-6v33M21 42V20h16v22M5 42h38M13 21h4M13 27h4M13 33h4M26 26h6M26 32h6" />,
    gear: (
        <>
            <circle cx="24" cy="24" r="6" />
            <circle cx="24" cy="24" r="12" />
            <path d="M24 8v4M24 36v4M8 24h4M36 24h4M12.7 12.7l2.8 2.8M32.5 32.5l2.8 2.8M12.7 35.3l2.8-2.8M32.5 15.5l2.8-2.8" />
        </>
    ),
    homePercent: (
        <>
            <path d="M6 24 24 8l18 16M10 22v20h28V22" />
            <circle cx="20" cy="28" r="2.2" />
            <circle cx="28" cy="36" r="2.2" />
            <path d="m29 26-10 12" />
        </>
    ),
    chart: <path d="M6 42h38M9 40V32h6v8M19 40V26h6v14M29 40V20h6v14M9 22l11-8 6 4 14-11M34 7h6v6" />,
}

// Tight viewBox per icon (x, y, w, h) so the drawing's left edge aligns with the text
const SERVICE_BOX = {
    home: [6, 7, 36, 35],
    key: [8, 7, 33, 33],
    doc: [11, 5, 28, 38],
    pin: [11, 5, 26, 38],
    building: [4, 8, 40, 35],
    gear: [7, 7, 34, 34],
    homePercent: [5, 7, 38, 36],
    chart: [5, 6, 40, 37],
}

const ServiceIcon = ({ name }) => {
    const [x, y, w, h] = SERVICE_BOX[name]
    const height = 35
    return (
        <svg
            width={(height * w) / h}
            height={height}
            viewBox={`${x} ${y} ${w} ${h}`}
            fill="none"
            stroke="#d4a85f"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            style={{ display: 'block' }}
        >
            {SERVICE_ICONS[name]}
        </svg>
    )
}

const SERVICES = [
    {
        icon: 'home',
        title: 'Buying Property in Dubai',
        to: '/properties-for-sale',
        text: 'From apartments in Dubai Marina to villas in Arabian Ranches, we guide buyers through search, negotiation and DLD title transfer.',
    },
    {
        icon: 'key',
        title: 'Selling Property in Dubai',
        to: '/sell-property',
        text: 'Professional valuation, marketing and buyer-matching to sell at the best achievable price with minimum time on market.',
    },
    {
        icon: 'doc',
        title: 'Renting & Leasing',
        to: '/contact-us',
        text: 'Tenant sourcing and landlord representation across Dubai’s freehold and leasehold communities, with Ejari-compliant contracts.',
    },
    {
        icon: 'pin',
        title: 'Off-Plan Properties',
        to: '/projects',
        text: 'Access to Binghatti, Danube, Emaar, DAMAC, Sobha and other leading developers, with payment plan and ROI guidance.',
    },
    {
        icon: 'building',
        title: 'Commercial Real Estate',
        to: '/properties-for-sale',
        text: 'Office, retail and warehouse sales and leasing for businesses and investors.',
    },
    {
        icon: 'gear',
        title: 'Property Management',
        to: '/contact-us',
        text: 'Tenant sourcing, rent collection and maintenance coordination for hands-off rental income.',
    },
    {
        icon: 'homePercent',
        title: 'Mortgage Advisory',
        to: '/mortgage-calculator',
        text: 'Pre-approval and financing guidance with leading UAE banks, including our free Mortgage Calculator.',
    },
    {
        icon: 'chart',
        title: 'Investment Advisory',
        to: '/dubai-property-investment',
        text: 'Data-led guidance on rental yield, capital appreciation and the best-performing communities for ROI.',
    },
]

const arrowStyle = (side) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    [side]: 8,
    width: 38,
    height: 38,
    border: 0,
    background: 'transparent',
    color: 'rgba(255,255,255,0.75)',
    fontSize: 34,
    lineHeight: 1,
    padding: 0,
    cursor: 'pointer',
    zIndex: 2,
})

// Image box with prev / next arrows and a bottom fade for the label
const TypeSlider = ({ images, alt }) => {
    const [i, setI] = useState(0)
    const go = (e, dir) => {
        e.preventDefault()
        e.stopPropagation()
        setI((p) => (p + dir + images.length) % images.length)
    }
    return (
        <div style={{ position: 'relative', height: '100%', overflow: 'hidden', background: '#111' }}>
            <img
                src={images[i]}
                alt={alt}
                loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,0.75) 100%)',
                    pointerEvents: 'none',
                }}
            />
            <button type="button" aria-label="Previous" style={arrowStyle('left')} onClick={(e) => go(e, -1)}>
                ‹
            </button>
            <button type="button" aria-label="Next" style={arrowStyle('right')} onClick={(e) => go(e, 1)}>
                ›
            </button>
        </div>
    )
}

const PROPERTY_TYPES = [
    { label: 'Villas for Sale in Dubai', images: [TypeVilla, TypeHouses] },
    { label: 'Apartments for Sale in Dubai', images: [TypeTowers, TypeAerial] },
    { label: 'Townhouses for Sale in Dubai', images: [TypeHouses, TypeVilla] },
    { label: 'Penthouses for Sale in Dubai', images: [TypeSkyline, TypePenthouse] },
    { label: 'Off-Plan Properties Dubai', images: [TypeAerial, TypeTowers] },
    { label: 'Commercial Property Dubai', images: [TypeInterior, TypeHouses] },
]

const INSIGHTS = [
    { tag: 'Market Reports', title: 'Dubai Market Report: September 2026', text: '1,017 transactions worth AED 8.08B — where demand is strongest across freehold communities.', images: [TypeTowers, TypeAerial], to: '/reports' },
    { tag: 'Buying Guides', title: 'Off-Plan Buying Guide: Payment Plans & Handover', text: 'What to check before you commit: developer track record, escrow, payment schedule and ROI.', images: [TypeAerial, TypeSkyline], to: '/news' },
    { tag: 'Investment', title: 'Rental Yield by Area: Where Investors Earn Most', text: 'Comparing gross yields across JVC, Business Bay, Dubai Marina and Dubai Hills Estate.', images: [TypeSkyline, TypeTowers], to: '/news' },
]
const FAQS = [
    ['Can foreigners buy property in Dubai?', 'Yes. Foreign nationals can buy freehold property in designated areas with full ownership rights.'],
    ['How do I choose a real estate agency in Dubai?', 'Check RERA registration, agent BRN cards, transaction record and client reviews.'],
    ['What are the costs of buying property in Dubai?', 'Typical costs include the 4% DLD transfer fee, agency commission and trustee fees.'],
    ['Is there tax on property in Dubai?', 'No annual property tax and no personal income tax on rental income.'],
    ['Can I get a Golden Visa through property?', 'Qualifying investments can lead to a 10-year Golden Visa. Our advisors confirm requirements.'],
    ['Should I buy off-plan or ready property?', 'Off-plan offers flexible payment plans; ready property gives immediate rental income.'],
    ['Do you help with mortgages?', 'Yes. We compare UAE bank offers for residents and non-residents.'],
    ['Do you manage rental properties?', 'Yes. We handle tenant search, leasing, maintenance and rent collection.'],
]
const COMMUNITIES = [
    { name: 'Downtown Dubai', img: TypeSkyline },
    { name: 'Dubai Marina', img: CommTerrace },
    { name: 'Palm Jumeirah', img: CommPalm },
    { name: 'Business Bay', img: CommLounge },
    { name: 'Dubai Hills Estate', img: TypeVilla },
    { name: 'Jumeirah Village Circle', img: TypeHouses },
    { name: 'JBR', img: TypePenthouse },
    { name: 'Arabian Ranches', img: TypeVilla },
    { name: 'Al Barsha', img: TypeTowers },
    { name: 'Emirates Hills', img: CommBedroom },
]

const INVEST_ICONS = {
    passport: (
        <>
            <path d="M13 7h22v34H13z" />
            <circle cx="24" cy="21" r="6" />
            <path d="M18 21h12M24 15v12M18 34h12" />
        </>
    ),
    percent: (
        <>
            <circle cx="17" cy="17" r="5" />
            <circle cx="31" cy="31" r="5" />
            <path d="M34 12 14 36" />
        </>
    ),
    house: <path d="M7 24 24 9l17 15M11 21v20h26V21M20 41V30h8v11" />,
    growth: <path d="M7 41h34M10 39V30h6v9M20 39V24h6v15M30 39V18h6v21M10 20l12-8 6 5 12-10M34 7h6v6" />,
    shield: (
        <>
            <path d="M24 6 38 11v13c0 9-7 15-14 18-7-3-14-9-14-18V11z" />
            <path d="m17 21 7-5 7 5M18 23v8M24 23v8M30 23v8M16 33h16" />
        </>
    ),
}

const WHY_INVEST = [
    {
        icon: 'passport',
        title: 'Golden Visa',
        text: 'Qualifying property investments can lead to 10-year UAE residency.',
    },
    {
        icon: 'percent',
        title: '0% Property & Income Tax',
        text: 'No annual property tax or personal income tax on rental income.',
    },
    { icon: 'house', title: '100% Freehold Ownership', text: 'Foreign buyers can own outright in designated areas.' },
    { icon: 'growth', title: 'Rental Yield & ROI', text: 'Competitive yields, among the strongest of global cities.' },
    { icon: 'shield', title: 'Market Stability', text: 'DLD and RERA regulation with escrow-protected sales.' },
]

const EXPERTS = [
    { name: 'Faraaz Siddiqui', role: 'General Manager', area: 'Dubai real estate specialist', img: ExpertFaraaz, to: '/faraaz-siddiqui' },
    { name: 'Bhwna Manvani', role: 'Sales Director', area: 'Dubai real estate specialist', img: ExpertBhwna, to: '/bhwna-manvani' },
    { name: 'Aanil Mannwani', role: 'Sales Director', area: 'Dubai real estate specialist', img: ExpertAanil, to: '/aanil-mannwani' },
    { name: 'Lakshay Choudhary', role: 'Property Consultant', area: 'Dubai real estate specialist', img: ExpertLakshay, to: '/lakshay-choudhary' },
]
const GMB_URL =
    'https://www.google.com/maps/place/800Homes+Real+Estate+Brokerage+LLC/@25.041544,55.1162041,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f13b09fd3f0b5:0xd6f8b83178154e03!8m2!3d25.041544!4d55.1162041!16s%2Fg%2F11wmt11z16'

const FALLBACK_REVIEWS = {
    rating: 4.8,
    total: 19,
    reviews: [
        { name: 'Munazza Tazkeer', area: '7 months ago', rating: 5, text: '“I had the opportunity to interact with Mr. Faraaz from 800 Homes UAE during one of their roadshows in Riyadh and it was genuinely a great experience. He’s extremely well-versed with the UAE real estate market.…”' },
        { name: 'Shumaira Siddiqui', area: '7 months ago', rating: 5, text: '“I had a great experience with 800HOMES Real Estate Brokerage. The team was professional, responsive, and very knowledgeable about the Dubai market. Highly recommended!”' },
        { name: 'Sales', area: '8 months ago', rating: 5, text: '“The company possesses extensive experience and expertise in real estate, dealing with both completed and under-construction projects.…”' },
    ],
}
// Live reviews: set REACT_APP_GOOGLE_PLACES_KEY (Places API (New) enabled, key restricted to your domain)
const useGoogleReviews = () => {
    const [data, setData] = useState(FALLBACK_REVIEWS)
    useEffect(() => {
        const key = process.env.REACT_APP_GOOGLE_PLACES_KEY
        if (!key) return
        fetch('https://places.googleapis.com/v1/places:searchText', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': key,
                'X-Goog-FieldMask': 'places.rating,places.userRatingCount,places.reviews',
            },
            body: JSON.stringify({ textQuery: '800Homes Real Estate Brokerage LLC Dubai', locationBias: { circle: { center: { latitude: 25.041544, longitude: 55.1162041 }, radius: 500 } } }),
        })
            .then((r) => r.json())
            .then((d) => {
                const place = d.places && d.places[0]
                if (!place || !place.reviews || !place.reviews.length) return
                setData({
                    rating: place.rating,
                    total: place.userRatingCount,
                    reviews: place.reviews.map((r) => ({
                        name: r.authorAttribution && r.authorAttribution.displayName,
                        photo: r.authorAttribution && r.authorAttribution.photoUri,
                        area: r.relativePublishTimeDescription,
                        rating: r.rating,
                        text: `“${(r.text && r.text.text) || (r.originalText && r.originalText.text) || ''}”`,
                    })),
                })
            })
            .catch(() => {})
    }, [])
    return data
}
const GoogleReviewsSection = () => {
    const { rating, total, reviews } = useGoogleReviews()
    const stars = (n) => '★'.repeat(Math.round(n)) + '☆'.repeat(5 - Math.round(n))
    return (
        <section className="container-lg">
            <div className="text-center">
                <div className="text-ss-primary fs-ss-18 fw-400">Google Reviews</div>
                <h2 className="text-white fs-ss-35 fw-500 lh-sm">What Our Clients Say</h2>
                <div className="text-white fs-ss-16 fw-300 pt-3 pb-md-4 pb-3">
                    <span className="text-ss-primary">{stars(rating)}</span> {rating} on Google{total ? ` · ${total} reviews` : ''}
                </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
                {reviews.slice(0, 3).map((r, i) => (
                    <div key={i} className="p-4 text-white" style={{ border: '1px solid rgba(255,255,255,0.25)' }}>
                        {r.photo ? (
                            <img src={r.photo} alt={r.name} width={44} height={44} className="rounded-circle mb-2" referrerPolicy="no-referrer" />
                        ) : (
                            <div className="rounded-circle bg-ss-primary d-flex align-items-center justify-content-center fw-500 mb-2" style={{ width: 44, height: 44 }}>
                                {(r.name || 'G').replace('[', '').charAt(0)}
                            </div>
                        )}
                        <div className="text-ss-primary fs-ss-14 mb-2">{stars(r.rating)}</div>
                        <p className="fs-ss-15 fw-300 lh-1-7em" style={{ display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{r.text}</p>
                        <div className="fs-ss-16 fw-500">{r.name}</div>
                        {r.area && <div className="fs-ss-14 fw-300" style={{ opacity: 0.6 }}>{r.area}</div>}
                    </div>
                ))}
            </div>
            <div className="pt-5 text-white fs-ss-18 fw-400 text-center">
                <a href={GMB_URL} target="_blank" rel="noopener noreferrer" className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5">
                    View All Reviews
                </a>
            </div>
        </section>
    )
}
const HomeNew = () => {
    const [counterOn, setCounterOn] = useState(false)
    const [transactionData, setTransactionData] = useState({})
    const [stripOn, setStripOn] = useState(false)
    const stripRef = useRef(null)

    useEffect(() => {
        const el = stripRef.current
        if (!el) return undefined
        const observer = new IntersectionObserver(([entry]) => setStripOn(entry.isIntersecting), {
            threshold: 0.6,
        })
        observer.observe(el)
        return () => observer.disconnect()
    }, [])
    const stripStats = [
        { end: 12, suffix: '+', label: 'Years in Dubai Real Estate' },
        { prefix: 'AED ', end: 3.2, decimals: 1, suffix: 'B', label: 'in Transactions' },
        { end: 12345, label: 'RERA ORN – RERA Registered' },
        { end: 4.9, decimals: 1, suffix: ' ★', label: 'Google Rating' },
    ]
    const [editMode, setEditMode] = useState(false)
    const [bannerContent, setBannerContent] = useState({
        title: (
            <>
                {' '}
                Real Estate Agency <br /> in Dubai Buy, Sell & <br /> Invest with Confidence{' '}
            </>
        ),
        description:
            '800 Homes is a RERA-registered real estate agency in Dubai helping buyers, sellers, and investors navigate the city’s property market with verified listings, transparent advice, and full transaction support — from your first viewing to the final title deed transfer.',
        buttonText: 'Speak to an Expert',
    })

    useEffect(() => {
        fetchTransactionData()
    }, [])

    const fetchTransactionData = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/transaction`)
            setTransactionData(data?.result || {})
        } catch (error) {
            console.error('transaction data', error)
            setTransactionData({})
        }
    }

    const num = (v) => {
        const n = Number(v)
        return Number.isFinite(n) ? n : 0
    }
    const countDecimals = (v) => {
        const n = Number(v)
        if (!Number.isFinite(n)) return 0
        const s = String(n)
        const i = s.indexOf('.')
        return i >= 0 ? s.length - i - 1 : 0
    }

    const transactionVal = num(transactionData?.transaction)
    const propertySaleVal = num(transactionData?.property_sale)
    const unitSoldVal = num(transactionData?.unit_sold)

    const tDecimals = countDecimals(transactionData?.transaction)
    const pDecimals = countDecimals(transactionData?.property_sale)
    const uDecimals = countDecimals(transactionData?.unit_sold)

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Real Estate Agency Dubai | Find Your Ideal Property | 800 Homes</title>
                <meta
                    name="description"
                    content="800 Homes is a RERA-registered real estate agency in Dubai helping buyers, sellers and investors with verified listings, transparent advice and full transaction support."
                />
                <meta name="robots" content="noindex, follow" />
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Libre+Caslon+Text:wght@400&family=Montserrat:wght@300&display=swap"
                />
            </Helmet>

            <section id="website-responsive" className="container-fluid px-0">
                {/* Hero Banner with Stats Strip */}
                <section
                    className="container-fluid bg-home-banner bg-home vh-100 px-0 d-flex flex-column"
                    style={{ backgroundImage: `url(${BannerImg})`, overflowX: 'hidden' }}
                >
                    <Header />
                    <div className="d-flex align-items-center flex-grow-1 px-4">
                        <div className="col-10 mx-auto">
                            <h1
                                className="text-white fw-500 pb-3"
                                style={{
                                    textTransform: 'uppercase',
                                    lineHeight: '1.2',
                                    fontSize: 'clamp(34px, 4.8vw, 55px)',
                                }}
                            >
                                {bannerContent.title}
                            </h1>
                            <p className="text-white fs-ss-18 fw-300 pb-4 lh-1-7em" style={{ maxWidth: '650px' }}>
                                {bannerContent.description}
                            </p>
                            <div className="d-flex gap-3">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                    style={{ display: 'inline-block', fontSize: '16px', fontWeight: '500' }}
                                >
                                    {bannerContent.buttonText}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stats Strip Section */}
                <div ref={stripRef}>
                    <section
                        style={{
                            backgroundColor: '#1d1d1f',
                            borderTop: '1px solid rgba(183, 139, 76, 0.45)',
                            borderBottom: '1px solid #2a2a2a',
                            padding: '40px 20px',
                        }}
                    >
                        <div
                            className="text-center"
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '24px',
                                maxWidth: '1240px',
                                margin: '0 auto',
                            }}
                        >
                            {stripStats.map((s) => (
                                <div key={s.label}>
                                    <div style={{ color: '#b78b4c', fontSize: '28px', fontWeight: '600' }}>
                                        {s.prefix}
                                        {stripOn ? (
                                            <CountUp
                                                start={0}
                                                end={s.end}
                                                decimals={s.decimals || 0}
                                                separator=""
                                                duration={3}
                                            />
                                        ) : (
                                            (0).toFixed(s.decimals || 0)
                                        )}
                                        {s.suffix}
                                    </div>
                                    <div
                                        style={{
                                            color: '#e6e6e6',
                                            fontSize: '15px',
                                            fontWeight: '300',
                                            marginTop: '4px',
                                        }}
                                    >
                                        {s.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>

                <section className="py-md-5 py-4" />

                {/* Why Choose Section */}
                <section className="container-fluid">
                    <div className="row justify-content-evenly gy-4">
                        <div className="col-11 col-md-6">
                            <div className="col-md-8 ps-lg-2 mx-auto">
                                <div className="pb-2 pb-md-4 text-ss-primary fs-ss-18 fw-400">
                                    Invest in Dubai Real Estate
                                </div>
                                <h2 className="pb-md-3 text-white fs-ss-40 fw-500 lh-sm">
                                    Why Choose 800 Homes as Your Real Estate Agency in Dubai?
                                </h2>
                            </div>
                        </div>
                        <div className="col-11 col-md-6 col-lg-5">
                            <div className="pb-4 text-white fs-ss-16 fw-300 col-md-10 pe-lg-5 lh-1-7em">
                                800 Homes is a RERA-registered real estate brokerage operating under Dubai Land
                                Department regulations, with ORN [Number] and a team of licensed real estate agents
                                based in Al Barsha, Dubai. We provide end- to-end support across buying, selling,
                                renting, and investing - including off-plan property advisory, mortgage guidance, and
                                after-sales support - so every transaction is handled with full transparency and DLD-
                                compliant documentation. Whether you're a first-time buyer, a landlord, or an
                                international investor, our team gives you practical, market-tested advice at every
                                stage.
                            </div>
                            <div className="pb-md-3 text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Contact for Details
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                <section className="pt-4 pt-md-0" />

                {/* Our Real Estate Services */}
                <section className="container-fluid">
                    <div className="text-center pb-4 pb-md-5">
                        <h2 className="fs-ss-30 text-white text-uppercase fw-600">Our Real Estate Services</h2>
                        <div className="text-white fs-ss-16 fw-300 pt-2">
                            Eight dedicated services, each with its own page.
                        </div>
                    </div>
                    <div className="container-lg">
                        {[SERVICES.slice(0, 4), SERVICES.slice(4)].map((row, r) => (
                            <div
                                className={`row g-0${r ? ' mt-4 pt-4' : ''}`}
                                key={r}
                                style={r ? { borderTop: '1px solid #3a3a3a' } : undefined}
                            >
                                {row.map((s, i) => (
                                    <div className="col-12 col-md-6 col-lg-3" key={s.title}>
                                        <Link
                                            to={s.to}
                                            className="d-block text-decoration-none text-white h-100"
                                            style={{
                                                padding: '6px 26px 28px',
                                                borderLeft: i ? '1px solid #3a3a3a' : 0,
                                            }}
                                        >
                                            <ServiceIcon name={s.icon} />
                                            <span
                                                style={{
                                                    display: 'block',
                                                    width: 32,
                                                    height: 1.5,
                                                    background: '#d4a85f',
                                                    margin: '12px 0 24px',
                                                }}
                                            />
                                            <h3
                                                style={{
                                                    fontFamily: "'Libre Caslon Text', Georgia, serif",
                                                    fontWeight: 400,
                                                    fontSize: 18,
                                                    lineHeight: 1.28,
                                                    marginBottom: 15,
                                                }}
                                            >
                                                {s.title}
                                            </h3>
                                            <p
                                                style={{
                                                    fontFamily: "'Montserrat', sans-serif",
                                                    fontWeight: 300,
                                                    fontSize: 14,
                                                    lineHeight: 1.8,
                                                    color: '#dcdcdc',
                                                    margin: 0,
                                                }}
                                            >
                                                {s.text}
                                            </p>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Explore Properties by Type */}
                <section className="container-lg">
                    <div className="text-center pb-3 pb-md-4">
                        <div className="text-ss-primary fs-ss-18 fw-400">Browse by Category</div>
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm pb-2">Explore Properties by Type</h2>
                        <div className="text-white fs-ss-16 fw-300 lh-1-7em mx-auto pb-3" style={{ maxWidth: 820 }}>
                            Browse apartments, villas, townhouses, penthouses, off-plan and commercial properties — each
                            verified and updated directly from the Dubai market.
                        </div>
                    </div>
                    <div className="row g-3">
                        {PROPERTY_TYPES.map((t) => (
                            <div className="col-12 col-md-6 col-lg-4" key={t.label}>
                                <Link
                                    to="/properties-for-sale"
                                    className="d-block position-relative text-decoration-none"
                                    style={{ height: 270, border: '1px solid #4a4a4a' }}
                                >
                                    <TypeSlider images={t.images} alt={t.label} />
                                    <span
                                        className="text-white fw-600 fs-ss-18"
                                        style={{
                                            position: 'absolute',
                                            left: 16,
                                            bottom: 14,
                                            zIndex: 3,
                                            pointerEvents: 'none',
                                        }}
                                    >
                                        {t.label}
                                    </span>
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                <section className="pt-4 pt-md-0" />

                {/* Transactions */}
                <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                    <section id="numbers" className="container-lg">
                        <div className="row justify-content-center text-center px-md-5 gy-4">
                            <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">Dubai Real Estate Transactions</h2>

                            <div className="col-md border-white border-end border-1">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={transactionVal}
                                            decimals={tDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.transaction_unit ? ` ${transactionData.transaction_unit}` : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Total Transactions in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>

                            <div className="col-md border-white border-end border-1">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={propertySaleVal}
                                            decimals={pDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.property_sale_unit
                                        ? ` ${transactionData.property_sale_unit}`
                                        : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Property Sales in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>

                            <div className="col-md">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={unitSoldVal}
                                            decimals={uDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.unit_sold_unit ? ` ${transactionData.unit_sold_unit}` : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Units Sold in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>
                        </div>

                        <div
                            className="text-white fs-ss-16 fw-300 lh-1-7em text-center mx-auto pt-4 pt-md-5"
                            style={{ maxWidth: 780 }}
                        >
                            Dubai’s real estate market recorded 11,431 total transactions worth AED 29.66 billion in
                            September, 2026, with 9,745 units sold across the city’s freehold communities — continuing
                            the market’s multi-year growth trend driven by population growth, Golden Visa investment and
                            strong rental demand.
                        </div>
                    </section>
                </ScrollTrigger>

                <section className="py-md-5 py-4" />
                <section
                    id="bg-middle-banner"
                    className="container-fluid bg-middle-banner py-5"
                    style={{ backgroundImage: `url(${BgMiddle})` }}
                >
                    <div className="row justify-content-evenly gy-4 py-md-5">
                        <div className="col-11 col-md-9 mx-auto">
                            <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-600 col-lg-7">
                                Find the Right Dubai Property for Your Next Move
                            </h2>
                            <div className="pb-3 pb-md-4 text-white fs-ss-18 fw-300 col-lg-7 lh-1-7em">
                                More space for family life, a shorter commute or a property investment start with what
                                matters to you. Explore apartments and villas for sale in Dubai, with ready and off-plan
                                options to suit your plans.Consider the location, upfront costs and purchase timeline
                                alongside the asking price. Share your priorities with 800 Homes, your real estate
                                agency in Dubai, to help narrow your search.
                            </div>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Talk to a Property Advisor
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Most Sought-After Communities */}
                <section className="container-lg">
                    <div className="text-center pb-3 pb-md-4">
                        <div className="text-ss-primary fs-ss-18 fw-400">Where to Buy</div>
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm pb-2">
                            Explore Dubai’s Most Sought-After Communities
                        </h2>
                        <div className="text-white fs-ss-16 fw-300 lh-1-7em mx-auto pb-4" style={{ maxWidth: 820 }}>
                            From the waterfront towers of Dubai Marina and Palm Jumeirah to the family-friendly villas
                            of Arabian Ranches and Dubai Hills Estate, our local experts help you find the right
                            community.
                        </div>
                    </div>
                    <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {COMMUNITIES.map((c) => (
                            <div className="col" key={c.name}>
                                <Link
                                    to="/properties-for-sale"
                                    className="d-block position-relative text-decoration-none overflow-hidden"
                                    style={{ height: 230, border: '1px solid #333' }}
                                >
                                    <img
                                        src={c.img}
                                        alt={`${c.name} properties`}
                                        loading="lazy"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background:
                                                'linear-gradient(180deg, rgba(0,0,0,0.1) 40%, rgba(0,0,0,0.8) 100%)',
                                        }}
                                    />
                                    <div style={{ position: 'absolute', left: 9, right: 6, bottom: 8, zIndex: 2 }}>
                                        <div className="text-white fw-600 fs-ss-15 lh-sm">{c.name}</div>
                                        <div className="text-ss-primary fw-500 fs-ss-14 pt-1">View properties</div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Why Invest in Dubai Real Estate */}
                <section className="container-lg">
                    <div className="text-center pb-3 pb-md-5">
                        <div className="text-ss-primary fs-ss-18 fw-400">Investor Guide</div>
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm pb-2">Why Invest in Dubai Real Estate</h2>
                        <div className="text-white fs-ss-16 fw-300 lh-1-7em mx-auto" style={{ maxWidth: 820 }}>
                            Dubai offers 100% freehold ownership in designated areas, 0% personal income and capital
                            gains tax, and Golden Visa eligibility through qualifying property investment — backed by
                            one of the world’s most transparent registration systems.
                        </div>
                    </div>
                    <div className="row g-0 row-cols-1 row-cols-md-3 row-cols-lg-5 text-center">
                        {WHY_INVEST.map((w, i) => (
                            <div
                                className="col px-3 pb-4"
                                key={w.title}
                                style={i ? { borderLeft: '1px solid rgba(183, 139, 76, 0.45)' } : undefined}
                            >
                                <div
                                    className="mx-auto d-flex align-items-center justify-content-center"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '50%',
                                        border: '1.5px solid #b78b4c',
                                        marginBottom: 22,
                                    }}
                                >
                                    <svg
                                        width="38"
                                        height="38"
                                        viewBox="0 0 48 48"
                                        fill="none"
                                        stroke="#d4a85f"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        {INVEST_ICONS[w.icon]}
                                    </svg>
                                </div>
                                <h3
                                    className="text-white"
                                    style={{
                                        fontFamily: "'Libre Caslon Text', Georgia, serif",
                                        fontWeight: 400,
                                        fontSize: 20,
                                        lineHeight: 1.28,
                                    }}
                                >
                                    {w.title}
                                </h3>
                                <span
                                    style={{
                                        display: 'block',
                                        width: 32,
                                        height: 1.5,
                                        background: '#d4a85f',
                                        margin: '14px auto 18px',
                                    }}
                                />
                                <div className="text-white fs-ss-14 fw-300 lh-1-7em">{w.text}</div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center pt-3 pt-md-4 text-white fs-ss-18 fw-400">
                        <Link
                            to="/dubai-property-investment"
                            className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                        >
                            Learn More →
                        </Link>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Meet Our Real Estate Experts */}
                <section className="container-lg">
                    <div className="text-center pb-3 pb-md-5">
                        <div className="text-ss-primary fs-ss-18 fw-400">Licensed Advisors</div>
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm pb-2">Meet Our Real Estate Experts</h2>
                        <div className="text-white fs-ss-16 fw-300 lh-1-7em">
                            Every 800 Homes agent is individually RERA-certified and specializes in a specific Dubai
                            community.
                        </div>
                    </div>
                    <div className="row g-3 row-cols-1 row-cols-sm-2 row-cols-lg-4">
                        {EXPERTS.map((a) => (
                            <div className="col" key={a.name}>
                                <Link
                                    to={a.to}
                                    className="d-block h-100 text-decoration-none text-center"
                                    style={{ background: '#1f1f1f', border: '1px solid #3c3c3c' }}
                                >
                                    <img
                                        src={a.img}
                                        alt={a.name}
                                        loading="lazy"
                                        style={{
                                            width: '100%',
                                            aspectRatio: '1 / 1',
                                            objectFit: 'cover',
                                            objectPosition: 'top',
                                            display: 'block',
                                        }}
                                    />
                                    <div className="px-3 py-4">
                                        <h3 className="text-white fs-ss-22 fw-600 lh-sm mb-2">{a.name}</h3>
                                        <div className="text-white fs-ss-15 fw-300">{a.role}</div>
                                        <div className="text-white fs-ss-15 fw-300">{a.area}</div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                    <div className="text-center pt-4 pt-md-5 text-white fs-ss-18 fw-400">
                        <Link
                            to="/our-team"
                            className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                        >
                            View Full Team
                        </Link>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                <AwardsAndAchievementsSection />

                <section className="py-md-5 py-4" />

                {/* Partners */}
                <section className="container-fluid">
                    <div className="text-center">
                        <div className="text-ss-primary fs-ss-18 fw-400">Trusted Developers</div>
                        <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">
                            Partners in Property Excellence
                        </h2>
                    </div>
                    <div className="row justify-content-evenly align-items-center gy-0 px-4 px-md-5 mx-md-5">
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon1} className="w-100" alt="Developer Partner Logo 1" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon2} className="w-100" alt="Developer Partner Logo 2" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon3} className="w-100" alt="Developer Partner Logo 3" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon4} className="w-100" alt="Developer Partner Logo 4" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon5} className="w-100" alt="Developer Partner Logo 5" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon6} className="w-100" alt="Developer Partner Logo 6" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon7} className="w-100" alt="Developer Partner Logo 7" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon8} className="w-100" alt="Developer Partner Logo 8" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon9} className="w-100" alt="Developer Partner Logo 9" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon10} className="w-100" alt="Developer Partner Logo 10" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon11} className="w-100" alt="Developer Partner Logo 11" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon12} className="w-100" alt="Developer Partner Logo 12" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon13} className="w-100" alt="Developer Partner Logo 13" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon14} className="w-100" alt="Developer Partner Logo 14" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon15} className="w-100" alt="Developer Partner Logo 15" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon16} className="w-100" alt="Developer Partner Logo 16" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon17} className="w-100" alt="Developer Partner Logo 17" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon18} className="w-100" alt="Developer Partner Logo 18" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon19} className="w-100" alt="Developer Partner Logo 19" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons">
                            <img src={Icon20} className="w-100" alt="Developer Partner Logo 20" />
                        </div>
                        <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons d-block d-md-none" />
                    </div>
                </section>

                <section className="py-md-5 py-4 my-md-2" />
                <section className="pt-md-0" />

                <GoogleReviewsSection />
                <section className="py-md-5 py-4" />

                {/* Explore Properties */}
                <section className="container-lg">
                    <div className="text-center">
                        <div className="text-ss-primary fs-ss-18 fw-400">800 Homes</div>
                        <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">Explore Properties</h2>
                    </div>
                    <div id="testimonials" className="">
                        <HomeSliderListing />
                        <div className="pt-5 text-white fs-ss-18 fw-400 text-center">
                            <Link
                                to="/properties-for-sale"
                                className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                            >
                                View All
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                <section className="container-lg">
                    <div className="text-center">
                        <div className="text-ss-primary fs-ss-18 fw-400">800 Homes</div>
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm">Latest Insights</h2>
                        <div className="text-white fs-ss-16 fw-300 pb-4">Market reports and buying guides from our team.</div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24, alignItems: 'stretch' }}>
                        {INSIGHTS.map((a) => (
                            <div key={a.title} className="d-flex flex-column text-white" style={{ border: '1px solid rgba(255,255,255,0.25)' }}>
                                <div style={{ height: 210 }}>
                                    <TypeSlider images={a.images} alt={a.title} />
                                </div>
                                <div className="p-4 d-flex flex-column flex-grow-1">
                                    <div className="text-center mt-n4 mb-3">
                                        <span className="bg-ss-primary text-white fs-ss-14 fw-500 px-3 py-1 rounded-1">{a.tag}</span>
                                    </div>
                                    <div className="fs-ss-22 fw-500 lh-sm mb-3">{a.title}</div>
                                    <p className="fs-ss-15 fw-300 lh-1-7em">{a.text}</p>
                                    <div className="mt-auto pt-3">
                                        <Link to={a.to} className="text-decoration-none text-ss-primary fs-ss-16 fw-500">
                                            Read more →
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="pt-5 text-white fs-ss-18 fw-400 text-center">
                        <Link to="/news" className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5">
                            Read All Insights
                        </Link>
                    </div>
                </section>
                <section className="py-md-5 py-4" />
                <section className="container-lg">
                    <div className="text-center">
                        <h2 className="text-white fs-ss-35 fw-500 lh-sm">Dubai Real Estate FAQs</h2>
                        <div className="text-white fs-ss-16 fw-300 pb-4">
                            Straight answers to the questions buyers, sellers and investors ask most.
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, alignItems: 'start' }}>
                        {FAQS.map(([q, a]) => (
                            <details key={q} open className="p-4 text-white" style={{ border: '1px solid rgba(255,255,255,0.25)' }}>
                                <summary className="fs-ss-18 fw-500" style={{ cursor: 'pointer', listStyle: 'none' }}>
                                    ▾ {q}
                                </summary>
                                <p className="fs-ss-15 fw-300 lh-1-7em mb-0 pt-2">{a}</p>
                            </details>
                        ))}
                    </div>
                </section>
                <section className="py-md-5 py-4" />
                <section
                    className="text-center text-white d-flex align-items-center"
                    style={{ backgroundImage: `url(${BgMiddle})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: 340 }}
                >
                    <div className="container-lg py-5" style={{ maxWidth: 900 }}>
                        <h2 className="fs-ss-35 fw-500 lh-sm">Start Your Dubai Real Estate Journey Today</h2>
                        <p className="fs-ss-16 fw-300 lh-1-7em pt-3 pb-3">
                            Whether you’re buying your first home, selling an investment property, or exploring off-plan opportunities, 800 Homes’
                            RERA-registered team is ready to help. Call +971-58-574-6637 or contact us online.
                        </p>
                        <div className="d-flex justify-content-center flex-wrap text-white fs-ss-18 fw-400" style={{ gap: 16 }}>
                            <a href="tel:+971585746637" className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5">
                                Call Now
                            </a>
                            <Link
                                to="/contact-us"
                                className="text-decoration-none px-4 py-ss-2 text-white rounded-5"
                                style={{ border: '1px solid #b78b4c' }}
                            >
                                Contact Us
                            </Link>
                        </div>
                        <div className="fs-ss-14 fw-300 pt-5">
                            800 Homes · RERA ORN [Number] · Office 909A, 9th Floor, Ibn Batuta Gate Offices Building, Jebel Ali, Dubai · +971-58-574-6637 ·
                            inquiry@800homes.ae
                        </div>
                    </div>
                </section>
                <section className="pt-4 pt-md-0" />
                <Footer />
            </section>
        </>
    )
}

export default HomeNew
